import React from 'react';

export const NewsletterTab = ({ newsletter }) => (
  <div className="space-y-5">
    <h1 className="text-2xl font-bold text-gray-900">Newsletter ({newsletter.length})</h1>
    <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
      <table className="w-full">
        <thead>
          <tr className="border-b border-gray-100">
            <th className="text-left p-4 text-xs font-semibold text-gray-500 uppercase">Email</th>
            <th className="text-left p-4 text-xs font-semibold text-gray-500 uppercase">Date</th>
            <th className="text-left p-4 text-xs font-semibold text-gray-500 uppercase">Statut</th>
          </tr>
        </thead>
        <tbody>
          {newsletter.map(s => (
            <tr key={s.id} className="border-b border-gray-50">
              <td className="p-4 text-sm text-gray-900">{s.email}</td>
              <td className="p-4 text-sm text-gray-500">{new Date(s.subscribed_at).toLocaleDateString('fr-FR')}</td>
              <td className="p-4"><span className="text-xs font-medium bg-emerald-50 text-emerald-700 px-2.5 py-1 rounded-full">Actif</span></td>
            </tr>
          ))}
        </tbody>
      </table>
      {!newsletter.length && <p className="text-gray-400 text-center py-8 text-sm">Aucun abonne</p>}
    </div>
  </div>
);
